import React, { useState, useEffect, useRef } from "react";
import Header from "../../layouts/Header";
import {
  Form,
  Input,
  Upload,
  Button,
  Switch,
  Select,
  Row,
  Col,
  Tabs,
  Flex,
  Modal,
  Space,
  Table,
  TableProps,
  message,
  Tooltip,
} from "antd";
import {
  EditOutlined,
  DeleteOutlined,
  PlusCircleFilled,
  PlusCircleOutlined,
  SearchOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";
import PlusImg from "../../assets/icons/plus-circle-white.svg";

import styles from "./index.module.css";
import { Maintenance } from "./Maintenance/Maintenance";
import Purchasing from "./Purchasing/Purchasing";
import "./index.css";
import { useHistory } from "react-router-dom";
import location from "../../assets/icons/location1.svg";
import tool from "../../assets/icons/tool.svg";
import aperture from "../../assets/icons/aperture.svg";
import GroupListPopup from "./GroupListPopup";
import PartListPopup from "./PartListPopup";
import PartsList from "./PartsList";
import GenralTabContent from "./GenralTabContent";
import { useDispatch, useSelector } from "react-redux";
import {
  FetchCategoryList,
  addAssetEquip,
  assetTypes,
  fetchAssetList,
  AddSupplierToAsset,
  AddDocumentToAsset,
  fetchAssetByID,
  updateAsset,
  setSelectedParts,
} from "../../redux/actions/action";
import { axiosInstance as axios } from "../../redux/constants/axiosInstance";
import { API_URL } from "../../redux/constants/type";

import AssetsDocumentsTab from "./AssetsDocumentsTab";
import DeleteIcon from "../../assets/icons/DeleteIcon.svg";
import CurrencyInput from "react-currency-input";
import { FetchSuppliers } from "../../redux/actions/action";
import Xicon from "../../assets/icons/Xicon.svg";

import AppDatePicker from "../../components/Common/AppDatePicker";
import closeIcon from "../../assets/icons/x-circle.svg";
import Calendericon from "../../assets/icons/Calendar with interaction.svg";
import { Radio } from "@mui/material";
import { default as style } from "styled-components";
import { ROLES } from "../../utils/helpers/userRole";
import { fetchScreenTranslations } from "../../utils/helpers/translations";

const BpIcon = style("span")(() => ({
  borderRadius: "50%",
  width: 16,
  height: 16,
  boxShadow:
    "dark" === "dark"
      ? "0 0 0 1px rgb(16 22 26 / 40%)"
      : "inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)",
  backgroundColor: "dark" === "dark" ? "#FFFFFF" : "#f5f8fa",
  backgroundImage:
    "dark" === "dark"
      ? "linear-gradient(180deg,hsla(0,0%,100%,.05),hsla(0,0%,100%,0))"
      : "linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))",
  ".Mui-focusVisible &": {
    outline: "2px auto rgba(19,124,189,.6)",
    outlineOffset: 2,
  },
  "input:hover ~ &": {
    backgroundColor: "dark" === "dark" ? "#FFFFFF" : "#ebf1f5",
  },
  "input:disabled ~ &": {
    boxShadow: "none",
    background:
      "dark" === "dark" ? "rgba(57,75,89,.5)" : "rgba(206,217,224,.5)",
  },
}));

const BpCheckedIcon = style(BpIcon)({
  backgroundColor: "#00246A",
  backgroundImage:
    "linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))",
  "&:before": {
    display: "block",
    width: 0,
    height: 16,
    backgroundImage: "radial-gradient(#fff,#fff 28%,transparent 32%)",
    content: '""',
  },
  "input:hover ~ &": {
    backgroundColor: "#106ba3",
  },
});

const toCheckFieldList = ["supplierid", "internalId", "costprice"];
const newSupplier = {
  supplierid: "",
  suppliername: "",
  searchSupplierName: "",
  internalId: "",
  costprice: "",
  leadtime: "",
  showSupplierXIcon: false,
  showSupplierOptions: false,
};

function NewFacility({ pageName, type, assetType, state }) {
  const dispatch = useDispatch();

  const { TabPane } = Tabs;
  const { Option } = Select;

  const history = useHistory();
  const [form] = Form.useForm();
  const [form1] = Form.useForm();
  const [query, setQuery] = useState("");
  const assetId = window.localStorage.getItem("assetId");
  const roleAccess = window.localStorage.getItem("roleid");
  const assetDetails = useSelector((state) => state.user.fetchParticularAsset);
  const assetUpdateRes = useSelector((state) => state.user.assetUpdateRes);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [pictureButtonHover, setPictureButtonHover] = useState(false);
  const [isGroupModal, setIsGroupModal] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  const Formvalues = Form.useWatch([], form);
  const [assetsData, setAssetsData] = useState(assetDetails);
  const [assetsTypeInit, setAssetsTypeInit] = useState();
  const [picture, setPicture] = useState();
  const selectedParts = useSelector((state) => state.user.selectedParts);

  const [generalDetails, setGeneralDetails] = useState({
    client: "",
    category: "",
    barcode: "",
    account: "",
    aisle: "",
    row: "",
    bin: "",
    serialNumber: "",
    model: "",
    notes: "",
    mainAssets: "",
    mainContact: "",
    contactEmail: "",
    contactPhone: "",
    partName: "",
    locatedAtName: "",
  });
  const [assetsValidationErrors, setAssetsValidationErrors] = useState({
    assetsID: "",
    assetName: "",
    // Add more fields if needed
  });

  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Assets-Add").then((data) =>
      setFetchTranslationList(data),
    );
  }, []);

  const [activeTab, setActiveTab] = useState("general");

  const [openNewMaintainacePopup, setNewMaintenancePopup] = useState(false);

  const [updatedDoc, setUpdatedDoc] = useState([]);
  const [supplier, setSupplier] = useState([]);
  const [assetsList, setAssetsList] = useState([
    {
      supplierid: "",
      suppliername: "",
      searchSupplierName: "",
      internalId: "",
      // productcolor: "",
      costprice: "",
      // min: "",
      // max: "",
      // instock: 0,
      leadtime: "",
      showSupplierXIcon: false,
      showSupplierOptions: false,
    },
  ]);

  const [assetsListUpdated, setAssetsListUpdated] = useState([]);

  const [isAvailable, setIsAvailable] = useState(true);
  const [showUnavailibilityPopup, setShowUnavailibilityPopup] = useState(false);
  const [unavailibilityType, setType] = useState("Definitive");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [reason, setReason] = useState("");

  const fetchSuppliersProductList = useSelector(
    (state) => state.user.fetchSuppliersProduct,
  );

  const deleteBOMitemRes = useSelector((state) => state.user.deleteBOMitemRes);

  useEffect(() => {
    if (fetchSuppliersProductList.status === true) {
      setSupplier(fetchSuppliersProductList?.data);
    }
  }, [fetchSuppliersProductList]);

  const assetsListNewData = useSelector((state) => state.user.assetsListNew);

  const validateForm = () => {
    let isValid = true;

    const errors = {
      internalID: "",
      assetName: "",
    };

    // Validate Equipment part of

    // Validate Client
    if (!Formvalues.internalId && Formvalues.internalId !== "") {
      errors.internalID = "Please enter Internal ID";
      isValid = false;
    }
    if (!Formvalues.assetName && Formvalues.assetName !== "") {
      errors.assetName = `${
        assetType === "Equipment"
          ? "Please enter Equipment Name"
          : assetType === "Facility"
            ? "Please enter Facility Name"
            : "Please enter Part Name"
      }`;
      isValid = false;
    }

    // Update validation errors state
    setAssetsValidationErrors(errors);

    return isValid;
  };
  // const pictureinput = useRef(null);

  useEffect(() => {
    dispatch(setSelectedParts([]));
    dispatch(assetTypes());
    // if (type === "Update") dispatch(fetchAssetByID({ assetId }));
    if (type === "Update" && fetchSuppliersProductList.status === true)
      dispatch(fetchAssetByID({ assetId }));
    else {
      setAssetsData({});
      form.setFieldsValue({
        internalId: "",
        assetName: "",
        assetDescription: "",
        category: "",
        isActive: true,
      });
    }
  }, [deleteBOMitemRes, fetchSuppliersProductList]);

  useEffect(() => {
    // setActiveTab("general");
    setActiveTab(t("General"));
  }, []);

  useEffect(() => {
    if (type === "Update" && assetDetails.data) {
      setAssetsData(assetDetails.data);
      setPicture(assetDetails?.data?.picture);
      window.localStorage.setItem(
        "currentAsset",
        JSON.stringify(assetDetails.data),
      );
      form.setFieldsValue({
        internalId: assetDetails.data.internalId,
        assetName: assetDetails.data.assetName,
        assetDescription: assetDetails.data.assetDescription,
        category:
          assetDetails.data.generalDetails &&
          assetDetails.data.generalDetails.category
            ? assetDetails.data.generalDetails.category
            : "",
        isActive: assetDetails.data.isActive ? true : false,
      });
      setGeneralDetails({ ...assetDetails.data.generalDetails });
      dispatch(setSelectedParts(assetDetails.data.billOfMaterial || []));
      if (state && state == "CREATEMAINTAINANCE") {
        setActiveTab("maintenance");
        setNewMaintenancePopup(true);
        history.replace({ ...location, state: null });
      }
      if (
        assetDetails.data.assetsupplier &&
        assetDetails.data.assetsupplier.length > 0
      ) {
        let supplierObj = assetDetails.data.assetsupplier;
        var i;
        for (i = 0; i < supplierObj.length; i++) {
          supplierObj[i].supplierid = supplierObj[i]["supplierId"];
          supplierObj[i].costprice = supplierObj[i]["costPrice"];
          delete supplierObj[i].supplierId;
          delete supplierObj[i].costPrice;
          supplierObj[i].showSupplierXIcon = false;
          supplierObj[i].showSupplierOptions = false;
          if (typeof supplierObj[i]?.supplierid !== "undefined") {
            const filteredSuppliers = fetchSuppliersProductList?.data?.filter(
              (supplier) => supplier.supplierid === supplierObj[i]?.supplierid,
            );
            supplierObj[i].suppliername = filteredSuppliers[0]?.suppliername;
            supplierObj[i].searchSupplierName =
              filteredSuppliers[0]?.suppliername;
          }
        }
        setAssetsList(supplierObj);
        setAssetsListUpdated(supplierObj);
      }
    }
  }, [assetDetails]);

  const assetsTypeList = useSelector((state) => {
    return state.user.assetTypes;
  });
  useEffect(() => {
    productPartSuppliers();
  }, [assetsList]);

  useEffect(() => {
    if (assetsTypeList && assetsTypeList.length) {
      const filteredArray = assetsTypeList.filter(
        (item) => item.assetTypeName === assetType,
      );
      if (filteredArray.length) {
        setAssetsTypeInit(filteredArray[0].assetTypeid);
      }
    }
  }, [assetsTypeList]);

  const normFile = (e) => {
    if (Array.isArray(e)) {
      return e;
    }
    return e && e.fileList;
  };

  const formStyle = (prop) => {
    return { padding: "1rem", width: prop && "15rem" };
  };

  const error = () => {
    messageApi.open({
      type: "error",
      content: "This is an error message",
    });
  };

  const handleGeneralDetailsChange = (updatedDetails) => {
    setGeneralDetails(updatedDetails);
  };

  const [imgUploading, setImgUploading] = useState("");

  const handleFileUpload = async (e) => {
    setImgUploading("yes");
    const fileUploaded = e.target.files[0];

    const formData = new FormData();
    formData.append("file", fileUploaded);

    try {
      const response = await axios.put(
        `${API_URL}/api/Files/UploadToS3`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );

      if (response !== null) {
        let dataTemp = {
          ...assetsData,
          picture: response.data[0],
        };

        setPicture(response.data[0]);
        setImgUploading("Done");

        setAssetsData(dataTemp);
      } else {
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (assetUpdateRes?.status === true) {
      dispatch(fetchAssetList(1, 10, "activeSort", ""));
    }
  }, [assetUpdateRes]);

  const [buttonDisable, setButtonDisable] = useState(false);
  const [showError, setShowError] = useState(false);

  const onFinish = async (form) => {
    if (
      (Formvalues?.internalId ?? "").trim() === "" ||
      (Formvalues?.assetName ?? "").trim() === ""
    ) {
      setShowError(true);
      return false;
    }

    setButtonDisable(true);

    // const dummySubmit = document.getElementById('dummy-submit');
    // dummySubmit.click();
    // asc start
    let ascData = assetsData;
    delete ascData?.assetsupplier;
    // asc end
    if (type === "Update") {
      // asc remove empty object data from array below
      const filteredData = assetsListUpdated.filter(
        (item) => item.supplierid !== "",
      );
      if (updatedDoc?.length > 0) {
        updatedDoc.splice(0, assetsData?.assetdocs?.length);
        if (updatedDoc?.length > 0) {
          var docPayload = updatedDoc.filter((data) => data?.link);
        }
      }
      dispatch(
        updateAsset({
          assetId,
          // ...assetsData,
          ...ascData,
          assetsupplier: filteredData,
          assetType: assetDetails.data.assetType,
          generalDetails: { ...generalDetails },
          billOfMaterial: selectedParts ? selectedParts : [],
          assetdocs: docPayload ?? [],
          picture: picture,
        }),
      );

      if (assetsListUpdated.length > 0) {
        const updatedAssetsSuppliers = assetsListUpdated
          .map((supplier) => {
            const updatedCostPrice = supplier.costprice;
            return toCheckFieldList.reduce((acc, key) => {
              if (supplier.hasOwnProperty(key)) {
                acc[key] =
                  key === "costprice" ? updatedCostPrice : supplier[key];
              }
              return acc;
            }, {});
          })
          .filter((supplier) =>
            toCheckFieldList.every((key) => supplier[key].toString()),
          );
        if (updatedAssetsSuppliers.length > 0) {
          // updatedAssetsSuppliers.splice(0, assetsData.assetsupplier.length);
          if (updatedAssetsSuppliers.length > 0) {
            const payload = {
              assetId,
              assetsupplier: updatedAssetsSuppliers,
            };
            // dispatch(AddSupplierToAsset(payload));
          }
        }
      }

      // if (updatedDoc.length > 0) {
      //   updatedDoc.splice(0, assetsData.assetdocs.length);
      //   if (updatedDoc.length > 0) {
      //     const payload = {
      //       assetid: assetId,
      //       assetdocs: updatedDoc.filter((data) => data?.link),
      //     };
      //     dispatch(AddDocumentToAsset(payload));
      //   }
      // }

      setTimeout(() => {
        history.push("/asset-management");
      }, 1500);
    } else {
      if (
        validateForm() &&
        Formvalues.internalId !== "" &&
        Formvalues.assetName !== ""
      ) {
        try {
          const payload = {
            billOfMaterial: selectedParts ? selectedParts : [],
            generalDetails: generalDetails,
            assetType: assetsTypeInit,
            ...Formvalues,
            picture: picture,
            isActive: isAvailable,
            turnOnUnavailibility: assetsData.turnOnUnavailibility,
          };

          // Dispatch the addAsset action to update Redux state and handle API call
          const response = await dispatch(addAssetEquip(payload));

          // setTimeout(() => {
          //   // message.success("add assets successfully");
          //   dispatch(fetchAssetList(1, 10, "activeSort", ""));
          history.push("/asset-management");
          // }, 200);

          // Handle the response if needed

          // message.success("Asset added successfully!");
          // Optionally, you can redirect the user to another page or perform other actions
        } catch (error) {}
      } else {
      }
    }
  };
  console.log("asc button dis", buttonDisable);

  useEffect(() => {
    if (assetsListNewData?.status === true) {
      if (assetsList.length > 0) {
        const updatedAssetsSuppliers = assetsList
          .map((supplier) => {
            const updatedCostPrice = supplier.costprice;
            return toCheckFieldList.reduce((acc, key) => {
              if (supplier.hasOwnProperty(key)) {
                acc[key] =
                  key === "costprice" ? updatedCostPrice : supplier[key];
              }
              return acc;
            }, {});
          })
          .filter((supplier) =>
            toCheckFieldList.every((key) => supplier[key].toString()),
          );
        if (updatedAssetsSuppliers.length > 0) {
          const payload = {
            assetId: assetsListNewData.data,
            assetsupplier: updatedAssetsSuppliers,
          };

          dispatch(AddSupplierToAsset(payload));
          history.push("/asset-management");
        }
      }
    }
  }, [assetsListNewData]);

  const handleAssetData = (supplierIndex, event, action) => {
    const updatedAssetsList = [...assetsList];
    if (event && event.target) {
      const { name, value } = event.target;
      updatedAssetsList[supplierIndex] = {
        ...updatedAssetsList[supplierIndex],
        [name.split("-")[0]]: value,
      };
      setAssetsList(updatedAssetsList);
      setAssetsListUpdated(updatedAssetsList);
    }

    if (action === "showOptions") {
      if (event?.target) {
        updatedAssetsList[supplierIndex].suppliername = event?.target
          ? event.target.value
          : "";
        updatedAssetsList[supplierIndex].searchSupplierName = event?.target
          ? event.target.value
          : "";
      } else {
        updatedAssetsList[supplierIndex].showSupplierOptions = true;
        setAssetsList(updatedAssetsList);
        setAssetsListUpdated(updatedAssetsList);
      }
    } else if (action === "hideOptions") {
      updatedAssetsList[supplierIndex].showSupplierOptions = false;
      updatedAssetsList[supplierIndex].searchSupplierName = "";
      setAssetsList([...updatedAssetsList]);
      setAssetsListUpdated([...updatedAssetsList]);
    } else if (action === "hideXIcon") {
      updatedAssetsList[supplierIndex].showSupplierXIcon = false;
      updatedAssetsList[supplierIndex].supplierid = "";
      updatedAssetsList[supplierIndex].suppliername = "";
      setAssetsList(updatedAssetsList);
      setAssetsListUpdated(updatedAssetsList);
    } else if (action === "selectSupplier") {
      updatedAssetsList[supplierIndex].supplierid = event.supplierid;
      updatedAssetsList[supplierIndex].suppliername = event.suppliername;
      updatedAssetsList[supplierIndex].showSupplierOptions = false;
      updatedAssetsList[supplierIndex].showSupplierXIcon = true;
      updatedAssetsList[supplierIndex].searchSupplierName = "";

      setAssetsList(updatedAssetsList);
      setAssetsListUpdated(updatedAssetsList);
    }
    productPartSuppliers();
  };

  const productPartSuppliers = () => {
    const existingSupplier = assetsList[(assetsList?.length || 1) - 1];
    const isAddNewSupplier = toCheckFieldList.every(
      (key) => existingSupplier.hasOwnProperty(key) && existingSupplier[key],
    );
    if (isAddNewSupplier) {
      setAssetsList([...assetsList, { ...newSupplier }]);
    }
  };

  const handleDeleteAssets = (index) => {
    // Check if there is only one supplier in the array
    if (assetsList.length === 1) {
      return;
    }
    const updatedSuppliers = [...assetsList];
    updatedSuppliers.splice(index, 1);
    setAssetsList(updatedSuppliers);
    setAssetsListUpdated(updatedSuppliers);
  };

  useEffect(() => {
    dispatch(FetchSuppliers());
  }, [dispatch]);

  useEffect(() => {
    const tab = localStorage.getItem("activeTab");
    setActiveTab(tab);
  }, []);

  useEffect(() => {
    if (activeTab) {
      localStorage.setItem("activeTab", activeTab);
    }
  }, [activeTab]);

  const CloseUnavailibilityPopup = (evt) => {
    evt.preventDefault();
    evt.stopPropagation();
    setShowUnavailibilityPopup(false);

    assetsData.isActive = true;
    setAssetsData(assetsData);
    setIsAvailable(true);
    form.setFieldsValue({
      isActive: true,
    });
  };

  const ConfirmAssetunavailibility = (evt) => {
    evt.preventDefault();
    evt.stopPropagation();
    setShowUnavailibilityPopup(false);

    assetsData.isActive = false;

    if (unavailibilityType === "Definitive") {
      let availibilityData = {
        isDefinitive: true,
        reason: reason,
      };

      if (assetId) {
        availibilityData.assetId = assetId;
      }

      assetsData.turnOnUnavailibility = availibilityData;
    } else {
      let availibilityData = {
        isTemporary: true,
        startDate: startDate,
        endDate: endDate,
      };

      if (assetId) {
        availibilityData.assetId = assetId;
      }

      assetsData.turnOnUnavailibility = availibilityData;
    }

    setAssetsData(assetsData);

    form.setFieldsValue({
      isActive: false,
    });
  };

  const handleInputChange = (changedValues, allValues) => {
    setAssetsData(allValues);
    setShowUnavailibilityPopup(!allValues.isActive);
  };

  // const [FetchTranslationList, setFetchTranslationList] = useState([]);
  // useEffect(() => {
  //   getScreenTranslations("Assets-Add").then((data) =>
  //     setFetchTranslationList(data)
  //   );
  // }, []);

  const hidden_Input_File = useRef(null);

  return (
    <div>
      <Header
        setQuery={setQuery}
        leftComponent={
          <div
            className="flex-wrap gap-2 d-flex flex-nowrap align-items-baseline"
            style={{ display: "flex", gap: "10%" }}
          >
            <div
              className="fw-bold"
              style={{
                fontSize: "16px",
                color: "#333333",
              }}
            >
              {/* Assets */}
              {t("Assets")}
            </div>
            <div className={`fw-bold dropdown2 col-3 w-full`}>
              <img
                src={
                  pageName === "New Part" || pageName === "Update Part"
                    ? tool
                    : pageName === "New Equipment" ||
                        pageName === "Update Equipment"
                      ? aperture
                      : location
                }
                alt=""
                style={{ width: "16px", height: "16px", marginRight: "15px" }}
              />
              <span
                onClick={() => {
                  //   history.push("/member-list");
                }}
              >
                {pageName}
              </span>
            </div>
          </div>
        }
      />

      {/* Action-Items */}
      <div className={styles.actionItems}>
        <Button
          type="default"
          style={{
            color: "#5b5b5b",
            border: "1px solid #00246A",
            borderRadius: "12px",
            width: "132px",
            height: "42px",
            fontSize: "14px",
            fontWeight: 700,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          // onClick={() => history.push("/asset-management")}
          onClick={() => history.goBack()}
        >
          {t("Cancel")}
        </Button>
        {roleAccess !== ROLES.VIEWER && roleAccess !== ROLES.USER && (
          <Button
            disabled={buttonDisable === true || imgUploading === "yes"}
            type="primary"
            style={{
              marginLeft: "12px",
              backgroundColor: "#00246A",
              color: "#ffffff",
              borderRadius: "12px",
              width: "132px",
              height: "42px",
              fontSize: "14px",
              fontWeight: 700,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            onClick={onFinish}
          >
            {type}
          </Button>
        )}
      </div>

      {/* Form */}
      <div className={styles.formContainer}>
        {/* Part1 */}
        <div
          style={{
            padding: "1rem 2rem",
            backgroundColor: "white",
            borderRadius: "12px",
            width: "100%",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
          className="assets-form-header"
        >
          <Form
            form={form}
            className={styles.formPart1}
            // labelCol={{ span: 6 }}
            wrapperCol={{ span: 24 }}
            layout="vertical"
            onValuesChange={handleInputChange}
            onFinish={onFinish}
            initialValues={{ active: true }}
          >
            <div
              className={`form-item-wrap ${
                assetsValidationErrors.internalID && "show-error"
              }`}
            >
              <Form.Item
                // label="Internal ID"
                label={t("Internal ID")}
                name="internalId"
                rules={[
                  { required: true, message: "Please Enter Internal ID" },
                ]}
                // validateStatus="error" // This highlights the border in red
                validateStatus={
                  showError && Formvalues?.internalId === "" && "error"
                }
              >
                <Input style={formStyle("partname")} />
              </Form.Item>
              {assetsValidationErrors.internalID && (
                <div className="error-message">
                  {assetsValidationErrors.internalID}
                </div>
              )}
            </div>

            <div
              class="assetImgBox pointer"
              style={{
                width: "145px",
                height: "50px",
                border: "1px solid #d9d9d9",
                borderRadius: "8px",
                marginTop: "-15px",
                objectFit: "cover",
                alignContent: "center",
              }}
              onClick={() => {
                hidden_Input_File.current.click();
              }}
            >
              {picture ? (
                <img
                  src={picture}
                  alt=""
                  className=""
                  style={{
                    width: "-webkit-fill-available",
                    height: "50px",
                    borderRadius: "8px",
                    objectFit: "cover",
                  }}
                />
              ) : (
                <div
                  className="d-flex gap-2 ps-4"
                  style={{
                    color: "#7E7E7E",
                  }}
                >
                  <img src={PlusImg} alt="" className="" />
                  {/* picture */}
                  <span>{t("Picture")}</span>
                </div>
              )}
            </div>

            <input
              multiple
              type="file"
              accept="image/*"
              ref={hidden_Input_File}
              style={{ display: "none" }}
              onChange={(e) => {
                // const fileUploaded = e.target.files[ 0 ];

                // const imageLoaded = URL.createObjectURL(fileUploaded);
                // setAdd_image(imageLoaded)

                handleFileUpload(e);
                // setChangeComp(e.target.value);
              }}
            />

            <div
              className={`form-item-wrap w-full  ${
                assetsValidationErrors.internalID && "show-error"
              }`}
            >
              <Form.Item
                label={
                  assetType === "Equipment"
                    ? t("Equipment Name")
                    : assetType === "Facility"
                      ? t("Facility Name")
                      : t("Part Name")
                }
                name="assetName"
                rules={[
                  {
                    required: true,
                    message: `${
                      assetType === "Equipment"
                        ? "Please enter Equipment Name"
                        : assetType === "Facility"
                          ? "Please enter Facility Name"
                          : "Please enter Part Name"
                    }`,
                  },
                ]}
                // validateStatus="error" // This highlights the border in red
                validateStatus={
                  showError && Formvalues?.assetName === "" && "error"
                }
              >
                <Input style={formStyle("partname")} />
              </Form.Item>
              {assetsValidationErrors.assetName && (
                <div className="error-message">
                  {assetsValidationErrors.assetName}
                </div>
              )}
            </div>
            <div className="form-item-wrap w-full">
              {assetType === "Equipment" || assetType === "Part" ? (
                <Form.Item label={t("Description")} name="assetDescription">
                  <Input style={formStyle("partname")} />
                </Form.Item>
              ) : (
                ""
              )}
            </div>
            <Form.Item
              label={t("Active?")}
              name="isActive"
              valuePropName="checked"
              className={`${styles.activeSwitch} switch-input-wrapper`}
            >
              {showUnavailibilityPopup && (
                <div className="unavailibility-card">
                  <div className="row selection">
                    <div className="col">Turn Unavailable</div>
                    <div className="col-3" onClick={CloseUnavailibilityPopup}>
                      {" "}
                      <img src={closeIcon} alt="" />
                    </div>
                  </div>
                  <div className="fc">
                    <div style={{ display: "flex" }}>
                      <Radio
                        checked={unavailibilityType === "Definitive"}
                        onClick={() => setType("Definitive")}
                        value="Definitive"
                        name="radio-buttons"
                        inputProps={{ "aria-label": "A" }}
                        checkedIcon={<BpCheckedIcon />}
                        icon={<BpIcon />}
                        size="small"
                        disableRipple={true}
                        disableFocusRipple={true}
                        sx={{
                          ":hover": {
                            backgroundColor: "transparent",
                          },
                        }}
                      />
                      <p
                        onClick={() => setType("Definitive")}
                        style={{
                          fontSize: "x-small",
                          marginTop: "10px",
                          cursor: "pointer",
                        }}
                      >
                        Definitive
                      </p>
                    </div>
                    <textarea
                      name="description"
                      className={"text-description-pop-1 w-auto"}
                      style={{
                        marginLeft: "8px",
                        maxWidth: "clamp(155px, 11.204vw, 11.204vw)",
                      }}
                      placeholder={"Type a reason"}
                      // value={""}
                      onChange={(e) => {
                        setReason(e.target.value);
                      }}
                    />
                    <div>
                      <div style={{ display: "flex" }}>
                        <Radio
                          checked={unavailibilityType === "Temporary"}
                          value="Temporary"
                          name="radio-buttons"
                          inputProps={{ "aria-label": "A" }}
                          checkedIcon={<BpCheckedIcon />}
                          onClick={() => setType("Temporary")}
                          icon={<BpIcon />}
                          size="small"
                          disableRipple={true}
                          disableFocusRipple={true}
                          sx={{
                            ":hover": {
                              backgroundColor: "transparent",
                            },
                          }}
                        />
                        <p
                          onClick={() => setType("Temporary")}
                          style={{
                            fontSize: "x-small",
                            marginTop: "10px",
                            cursor: "pointer",
                          }}
                        >
                          Temporary
                        </p>
                      </div>

                      <label
                        style={{
                          display: "flex",
                          width: "94%",
                          marginLeft: "8px",
                        }}
                      >
                        <p style={{ fontSize: "12px", opacity: ".5" }}>
                          From&nbsp;&nbsp;&nbsp;
                        </p>
                        <img
                          style={{ height: "15px", marginTop: "3px" }}
                          src={Calendericon}
                          alt="calender"
                        />
                        <AppDatePicker
                          onSelect={(d, event) => {
                            event.preventDefault();
                          }}
                          inputClassNames={"ms-1 equipment-date"}
                          dateFormat="dd/MM/yyyy"
                          className="calender-icon-date"
                          onChange={setStartDate}
                          placeholderText="dd/mm/yyyy"
                          selected={startDate}
                        />
                      </label>
                      <label
                        style={{
                          display: "flex",
                          marginLeft: "7px",
                          width: "94%",
                        }}
                      >
                        <p style={{ fontSize: "12px", opacity: ".5" }}>
                          To&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </p>
                        <img
                          style={{ height: "16px", marginTop: "3px" }}
                          src={Calendericon}
                          alt="calender"
                        />
                        <AppDatePicker
                          onSelect={(d, event) => {
                            event.preventDefault();
                          }}
                          inputClassNames={"ms-1 equipment-date"}
                          dateFormat="dd/MM/yyyy"
                          className="calender-icon-date"
                          onChange={setEndDate}
                          placeholderText="dd/mm/yyyy"
                          selected={endDate}
                        />
                      </label>
                      <div className="confirm-btn-div">
                        <button
                          className="confirm-btn"
                          onClick={ConfirmAssetunavailibility}
                        >
                          {t("Confirm")}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              <Switch
                className="custom-bg"
                checked={isAvailable}
                onChange={(check, e) => {
                  setIsAvailable(check);
                }}
              />
            </Form.Item>
          </Form>
        </div>

        {/* Part-2 */}
        <div className="assets-tab-content">
          <Form
            form={form1}
            style={{ width: "100%" }}
            // labelCol={{ span: 6 }}
            // wrapperCol={{ span: 12 }}
            layout="vertical"
            onFinish={onFinish}
          >
            <Tabs
              activeKey={activeTab}
              style={{ width: "100%" }}
              onTabClick={(key) => {
                setActiveTab(key);
              }}
            >
              <TabPane
                //  tab="General"
                tab={t("General")}
                key="general"
              >
                <GenralTabContent
                  validationErrors={assetsValidationErrors}
                  assetsType={assetType}
                  generalDetails={generalDetails}
                  onDetailsChange={handleGeneralDetailsChange}
                  type={type}
                  form={form1}
                />
              </TabPane>
              <TabPane
                // tab="BOM"
                tab={t("BOM")}
                key="bom"
              >
                <div className="bom-tab-wrapper">
                  <div className="bom-tab-header">
                    <Row gutter={20}>
                      <Col span={20}>
                        <Flex gap="small" className="bom-header-flex">
                          <PartListPopup />
                          <GroupListPopup />
                        </Flex>
                      </Col>
                      <Col span={4}>
                        <b className="total-count">
                          {/* Total Parts : {selectedParts?.length} */}
                          {t("Total Parts:")} : {selectedParts?.length}
                        </b>
                      </Col>
                    </Row>
                    <PartsList />
                  </div>
                </div>
              </TabPane>
              <TabPane
                //  tab="Maintenance"
                tab={t("Maintenance")}
                key="maintenance"
              >
                {/* Maintenance form fields */}
                <Maintenance
                  openNewMaintainacePopup={openNewMaintainacePopup}
                />
              </TabPane>
              <TabPane
                // tab="Purchasing"
                tab={t("Purchasing")}
                key="purchasing"
              >
                {/* Purchasing form fields */}
                <Purchasing assetsData={assetsData} />
              </TabPane>
              <TabPane
                //  tab="Supplier"
                tab={t("Supplier")}
                key="supplier"
              >
                <div
                  class="products-and-parts-content pe-4 ps-3"
                  style={{ overflowX: "auto" }}
                >
                  <div style={{ marginTop: "clamp(20px, 1.406vw, 1.406vw)" }}>
                    {assetsList?.map((item, index) => (
                      <div key={index} className="products-and-parts-stock-tab">
                        <div className="products-and-parts-toggle-area col-8">
                          <div
                            className="products-and-parts-asc-input-container"
                            id="products-and-parts-ascInput"
                          >
                            <label className="products-and-parts-asc-label-top products-and-parts-supplier-title">
                              {/* Supplier */}
                              {t("Supplier")}
                            </label>
                            <div
                              className={`${
                                item.showSupplierOptions
                                  ? "products-and-parts-tab-supplier-input-expanded ps-3"
                                  : "products-and-parts-tab-supplier-input ps-3"
                              }`}
                              // ref={refTypeDropDownContainer}
                            >
                              <input
                                type="text"
                                // placeholder={`${item.showSupplierOptions ? "Select a Supplier" : "Add a Supplier"
                                //   }`}
                                placeholder={`${
                                  item.showSupplierOptions
                                    ? t("Select a Supplier")
                                    : "Add a Supplier"
                                }`}
                                className="products-and-parts-supplier-text"
                                value={
                                  item.searchSupplierName || item.suppliername
                                }
                                name={`suppliername`}
                                onChange={(e) => {
                                  handleAssetData(index, e, "showOptions");
                                }}
                                onBlur={() => {
                                  setTimeout(() => {
                                    handleAssetData(index, null, "hideOptions");
                                  }, 500);
                                }}
                                onClick={() => {
                                  handleAssetData(index, null, "showOptions");
                                }}
                              />

                              {item.showSupplierXIcon && (
                                <img
                                  src={Xicon}
                                  className="pointer"
                                  alt=""
                                  onClick={() => {
                                    handleAssetData(index, null, "hideOptions");
                                    handleAssetData(index, null, "hideXIcon");
                                  }}
                                />
                              )}

                              {item.showSupplierOptions && (
                                <div
                                  // ref={refTypeDropDownContainerExclude}
                                  className="products-and-parts-supplier-customSelect_Outer"
                                >
                                  {supplier
                                    .filter((supplierItem) =>
                                      supplierItem.suppliername
                                        ?.toLowerCase()
                                        .includes(item.searchSupplierName),
                                    )
                                    .map((innerItem, ind) => {
                                      return (
                                        <div
                                          key={ind}
                                          className="products-and-parts-pointer products-and-parts-dropdown-spacing ulterDrop"
                                          onClick={() =>
                                            handleAssetData(
                                              index,
                                              innerItem,
                                              "selectSupplier",
                                            )
                                          }
                                          style={{
                                            backgroundColor:
                                              innerItem.suppliername ===
                                              item.suppliername
                                                ? "#F4F5F4"
                                                : "transparent",
                                          }}
                                        >
                                          {innerItem.suppliername}
                                        </div>
                                      );
                                    })}
                                  {supplier.length === 0 && (
                                    <span className="noDataDisplay">
                                      No data to display!
                                    </span>
                                  )}
                                </div>
                              )}
                            </div>
                          </div>
                          {/* Item ID */}
                          <div
                            className="products-and-parts-asc-input-container products-and-parts-icon-plus-input-container"
                            id="products-and-parts-ascInput"
                          >
                            <label className="products-and-parts-asc-label-top products-and-parts-item-id-title">
                              {/* Supplier ID */}
                              {t("Supplier ID")}
                            </label>

                            <input
                              type="text"
                              className="products-and-parts-stock-inputs products-and-parts-stock-item-id-input ps-4"
                              value={item.internalId}
                              name="internalId"
                              onChange={(e) => handleAssetData(index, e)}
                            />
                          </div>

                          <div
                            className="products-and-parts-asc-input-container products-and-parts-icon-plus-input-container"
                            id="products-and-parts-ascInput"
                          >
                            <label className="products-and-parts-asc-label-top products-and-parts-item-cost-price-title">
                              {/* Cost Price */}
                              {t("Cost Price")}
                            </label>
                            <CurrencyInput
                              className="products-and-parts-stock-inputs products-and-parts-lead-time-input"
                              placeholder="0"
                              name="costprice"
                              value={item.costprice}
                              onChangeEvent={(e) => {
                                handleAssetData(index, e);
                              }}
                              decimalSeparator=","
                              thousandSeparator="."
                              precision="2"
                              allowEmpty={true}
                              prefix="€ "
                            />
                          </div>

                          <div
                            className="products-and-parts-del-img"
                            onClick={() => handleDeleteAssets(index)}
                          >
                            <Tooltip title="Delete" color={"red"}>
                              <img
                                src={DeleteIcon}
                                className="pb-2 products-and-parts-pointer"
                                alt=""
                              />
                            </Tooltip>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </TabPane>
              {/* <TabPane
                // tab="Log"
                tab={FetchTranslationList[103]?.translation}
                key="log"
              >
                Log form fields
              </TabPane> */}
              <TabPane
                // tab="Documentation"
                tab={t("Documentation")}
                key="documentation"
              >
                <AssetsDocumentsTab
                  assetsData={assetsData}
                  type={type}
                  setUpdatedDoc={setUpdatedDoc}
                />
              </TabPane>
            </Tabs>
          </Form>
        </div>
      </div>

      {showUnavailibilityPopup && (
        <div
          className="unavailibility-backdrop"
          onClick={CloseUnavailibilityPopup}
        >
          &nbsp;&nbsp;
        </div>
      )}
    </div>
  );
}

export default NewFacility;
